import NativeSafeSelect from "../ui/NativeSafeSelect.jsx";

import {
  CARGO_BODY_TYPES,
} from "./performerCatalog.js";

export default function CargoAssetFields({
  form,
  setForm,
  setError,
  tr,
  inputStyle,
  labelStyle,
  bodyTypeLabel,
  vehiclePhotoFile,
  vehiclePhotoPreview,
  onVehiclePhotoChange,
}) {
  const change = (key) => (event) => {
    setError("");

    setForm((prev) => ({
      ...prev,
      [key]: event.target.value,
    }));
  };

  return (
    <>
      <NativeSafeSelect
        value={form.bodyType}
        onChange={(value) => {
          setError("");

          setForm((prev) => ({
            ...prev,
            bodyType: value,
            bodyTypeOther:
              value === "Другое"
                ? prev.bodyTypeOther
                : "",
          }));
        }}
        style={{ ...inputStyle, color: "white" }}
        ariaLabel={tr(
          "register.bodyType",
          "Тип кузова"
        )}
        options={[
          {
            value: "",
            label: tr(
              "register.bodyTypePick",
              "Выберите тип кузова"
            ),
          },
          ...CARGO_BODY_TYPES.map((value) => ({
            value,
            label: bodyTypeLabel(value),
          })),
        ]}
      />

      {form.bodyType === "Другое" ? (
        <input
          autoFocus
          placeholder={tr(
            "register.bodyTypeOther",
            "Уточните кузов"
          )}
          value={form.bodyTypeOther}
          onChange={change("bodyTypeOther")}
          style={inputStyle}
        />
      ) : null}

      <div style={labelStyle}>
        {tr(
          "register.capacityTons",
          "Грузоподъёмность, тонн"
        )}
      </div>

      <input
        type="number"
        inputMode="decimal"
        min="0.1"
        max="1000"
        step="0.1"
        placeholder="20"
        value={form.capacityTons}
        onChange={change("capacityTons")}
        style={inputStyle}
      />

      <div style={labelStyle}>
        {tr(
          "register.volumeM3",
          "Объём кузова, м³"
        )}
      </div>

      <input
        type="number"
        inputMode="decimal"
        min="0.1"
        max="10000"
        step="0.1"
        placeholder="82"
        value={form.volumeM3}
        onChange={change("volumeM3")}
        style={inputStyle}
      />

      <div style={labelStyle}>
        {tr(
          "register.vehiclePhoto",
          "Фото транспорта"
        )}
      </div>

      <div
        style={{
          border: "1px solid #334155",
          borderRadius: 16,
          padding: 12,
          marginBottom: 10,
          background: "rgba(30, 41, 59, 0.72)",
        }}
      >
        {vehiclePhotoPreview ? (
          <img
            src={vehiclePhotoPreview}
            alt={tr(
              "register.vehiclePhotoPreviewAlt",
              "Фото транспорта"
            )}
            style={{
              width: "100%",
              maxHeight: 230,
              objectFit: "cover",
              borderRadius: 12,
              display: "block",
              marginBottom: 10,
            }}
          />
        ) : null}

        <label
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            minHeight: 46,
            borderRadius: 14,
            border: "1px solid #3b82f6",
            background: vehiclePhotoFile ? "rgba(37, 99, 235, .18)" : "#2563eb",
            color: "white",
            fontWeight: 900,
            cursor: "pointer",
            padding: "10px 14px",
            textAlign: "center",
          }}
        >
          {vehiclePhotoFile
            ? tr(
                "register.vehiclePhotoReplace",
                "Заменить фото"
              )
            : tr(
                "register.vehiclePhotoPick",
                "Снять или выбрать фото"
              )}
          <input
            type="file"
            accept="image/*"
            capture="environment"
            onChange={(event) => {
              const file = event.target.files?.[0] || null;
              onVehiclePhotoChange?.(file);
              event.target.value = "";
            }}
            style={{ display: "none" }}
          />
        </label>

        <div
          style={{
            color: "#94a3b8",
            fontSize: 12,
            lineHeight: 1.45,
            marginTop: 9,
          }}
        >
          {tr(
            "register.vehiclePhotoHint",
            "Обязательное фото основного транспорта. Желательно показать автомобиль целиком и госномер."
          )}
        </div>
      </div>
    </>
  );
}
